import yup from "src/utils/yup/extensionMethods";

const perimissionsFinancialManagementSchema = (translate: Function) => yup.object().shape({
	permissions: yup.array().of(yup.object().shape({
		id: yup.string(),
		efa005Id: yup.string(),
		efa004Id: yup.string(),
		permission: yup.string()
	}))
		.unique(translate("Usuários não podem ser repetidos"), (a: any) => a.efa005Id, (a: any) => !a.efa004Id)
		.unique(translate("Grupo de Usuários não podem ser repetidos"), (a: any) => a.efa004Id, (a: any) => !a.efa005Id)
});

export default perimissionsFinancialManagementSchema;
